import React from "react";
import { AreaChart, Area, XAxis, ResponsiveContainer } from "recharts";

const Chart = ({ data }) => {
	const style = {
		top: "50%",
		right: 0,
		transform: "translate(0, -50%)",
		lineHeight: "24px",
	};

	return (
		<ResponsiveContainer width="100%" height="100%">
			<AreaChart data={data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
				<defs>
					<linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
						<stop offset="0%" stopColor="#FFFFFF" stopOpacity={0.4} />
						<stop offset="100%" stopColor="#FFFFFF" stopOpacity={0.1} />
					</linearGradient>
				</defs>
				<XAxis
					dataKey="day"
					axisLine={false}
					tickLine={false}
					tick={{ fill: 'white' }}
					padding={{ left: 0, right: 0 }}
				/>
				<Area
					type="monotone"
					dataKey="value"
					stroke="#FFFFFF"
					strokeWidth={2}
					fillOpacity={1}
					fill="url(#colorGradient)"
				/>
			</AreaChart>
		</ResponsiveContainer>
	);
};

export default Chart;


